<script setup>
import {useEventListener} from '@vueuse/core'

const emit = defineEmits(['loaded', 'progress'])

const props = defineProps({
  videoId: {
    type: String,
    required: true
  }
})

const containerId = ref()
const loaded = ref(false)
let cleanup = null
const playerWidth = ref(NaN)
const playerHeight = computed(() => {
  if (!playerWidth.value) return 0
  return parseInt(playerWidth.value) * 0.5625
})
const playerOptions = computed(() => {
  return {width: playerWidth.value + 'px', height: playerHeight.value + 'px'}
})

function onLoaded() {
  emit('loaded')
}

function onProgress(event) {
  emit('progress', event)
}

function onEnded() {
  emit('ended')
}

function onContainerResize() {
  const player = document.getElementById(containerId.value)

  if (!player) return

  playerWidth.value = player.offsetWidth
  player.style.height = playerHeight.value + 'px'

  loaded.value = true
}

onBeforeMount(() => {
  containerId.value = 'vi-player-container-' + Math.random().toString(36).substring(2, 9)
})

onMounted(async () => {
  cleanup = useEventListener(window, 'resize', onContainerResize)
  onContainerResize()
})

onBeforeUnmount(() => {
  if (cleanup) cleanup()
})

watch(containerId, () => {
  if (cleanup) cleanup()
  cleanup = useEventListener(window, 'resize', onContainerResize)

  onContainerResize()
})

defineExpose({
  refreshSize: onContainerResize
})
</script>

<template>
  <div v-if="containerId" :id="containerId" class="flex justify-center w-full">
    <ClientOnly>
      <ScriptVimeoPlayer
        v-if="loaded"
        @loaded="onLoaded"
        @progress="onProgress"
        @ended="onEnded"
        :id="props.videoId"
        :vimeo-options="playerOptions"
      >
        <template #awaitingLoad>
          <div
            class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-[48px] w-[68px] cursor-pointer">
            <img src="/img/play-btn.png" alt="Reproducir"/>
          </div>
        </template>
      </ScriptVimeoPlayer>
    </ClientOnly>
  </div>
</template>
